// Mantine
import { Button, Modal, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Next
import { useNavigate } from 'react-router-dom'

export default function ComponentDelete({ component }) {
    // Modal state
    const [opened, handlers] = useDisclosure()

    // Delete component
    const { requestDelete } = useAxiosApi()
    const navigate = useNavigate()

    const deleteComponent = async () => {
        await requestDelete(`/components/${component.id}`)

        // Redirect to components list
        navigate('/components')
    }

    return (
        <div className="p-5 border bg-white flex flex-col gap-3 items-start hidden">
            <span className="text-xl font-medium">Supression du composant</span>

            <Button onClick={() => handlers.open()} color="red">
                Supprimer {component.component_category.name_fr}
                {' — '}
                {component.name}
            </Button>

            <Modal
                opened={opened}
                onClose={() => handlers.close()}
                title="Supprimer le composant"
                size="md"
            >
                <div className="flex flex-col gap-3">
                    <Text>
                        Êtes-vous sûr de vouloir supprimer le composant{' '}
                        <strong>
                            {component.component_category.name_fr}
                            {' — '}
                            {component.name}
                        </strong>
                        ?
                    </Text>

                    <div className="grid grid-cols-2 gap-3">
                        <Button
                            onClick={() => handlers.close()}
                            variant="default"
                        >
                            Annuler
                        </Button>

                        <Button onClick={deleteComponent} color="red">
                            Supprimer
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
